import { render, staticRenderFns } from "./PosteDepense.vue?vue&type=template&id=5cc95b9c&scoped=true&"
import script from "./PosteDepense.js?vue&type=script&lang=js&"
export * from "./PosteDepense.js?vue&type=script&lang=js&"
import style0 from "./PosteDepense.vue?vue&type=style&index=0&id=5cc95b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc95b9c",
  null
  
)

export default component.exports